import React from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import QuizIcon from "@mui/icons-material/Quiz";

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_SOFT,
  BRAND_PRIMARY,
  BRAND_TINT_BG,
} from "./theme";

/**
 * A single mock-test card. Used by the book detail view and any other
 * surface that needs to render a public exam. The card stays purely
 * presentational — the caller decides what happens on Start.
 */
const MockTestCard = ({ exam, onStart }) => (
  <Card
    sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      borderRadius: 3,
      background: "rgba(255,255,255,0.95)",
      backdropFilter: "blur(10px)",
      border: "1px solid rgba(139,92,246,0.15)",
      transition: "all 0.3s ease",
      "&:hover": {
        transform: "translateY(-8px)",
        boxShadow: "0 20px 40px rgba(124,58,237,0.18)",
        borderColor: "rgba(139,92,246,0.45)",
      },
    }}
  >
    <CardContent sx={{ flexGrow: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5 }}>
        <Box
          sx={{
            p: 1,
            borderRadius: 2,
            background: BRAND_GRADIENT,
            display: "inline-flex",
            color: "white",
          }}
        >
          <QuizIcon fontSize="small" />
        </Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#0f172a", lineHeight: 1.3 }}
        >
          {exam.title}
        </Typography>
      </Box>
      {exam.description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {exam.description}
        </Typography>
      )}
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {exam.totalQuestions != null && (
          <Chip
            size="small"
            label={`${exam.totalQuestions} questions`}
            sx={{
              borderRadius: 2,
              borderColor: BRAND_PRIMARY,
              color: BRAND_PRIMARY,
              fontWeight: 600,
              bgcolor: BRAND_TINT_BG,
              border: "1px solid",
            }}
          />
        )}
        {(exam.tags || []).map((tag) => (
          <Chip key={tag} size="small" variant="outlined" label={tag} />
        ))}
      </Stack>
      {Array.isArray(exam.availableParts) && exam.availableParts.length > 0 && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 1.5 }}
        >
          Parts: {exam.availableParts.join(", ")}
        </Typography>
      )}
    </CardContent>
    <CardActions sx={{ p: 2, pt: 0 }}>
      <Button
        fullWidth
        startIcon={<PlayArrowIcon />}
        onClick={() => onStart(exam)}
        sx={{
          borderRadius: 2,
          py: 1.25,
          fontWeight: 600,
          textTransform: "none",
          fontSize: "1rem",
          color: "white",
          background: BRAND_GRADIENT,
          boxShadow: "0 6px 16px rgba(124,58,237,0.28)",
          "&:hover": { background: BRAND_GRADIENT_SOFT, opacity: 0.95 },
        }}
      >
        Start
      </Button>
    </CardActions>
  </Card>
);

export default MockTestCard;
